import React, { useState, useEffect } from 'react';
import HP1 from "../../assets/img/slider/Home_HLF_new.jpg";
import HP1Mobile from "../../assets/img/slider/Home_HLF_mobile3.jpg";
// import HP2Mobile from "../../assets/img/slider/Home_HLF_mobile2.jpg";
import Logo from "../../assets/img/logo/logoHLF.png";
import Slider from "react-slick";
import CloudbedsBookingWidget from './CloudbedsBookingWidget';
import { Link } from 'react-router-dom';

function Sliderhome() {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const home = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 900,
        autoplay: true,
        slidesToShow: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    }

    // Selección dinámica de imágenes
    const bg1 = isMobile ? HP1Mobile : HP1;
    // const bg2 = isMobile ? HP2Mobile : HP2;

    return (
        <>
            <section id="home" className="slider-area fix p-relative">
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 2 }}>
                    <div className="container h-100">
                        <div className="row justify-content-center align-items-center h-100">
                            <div className="col-lg-7 col-md-7">
                                <div className="slider-content s-slider-content text-center">
                                    <div className="d-flex justify-content-center">
                                        <img
                                            src={Logo}
                                            alt="Hotel Logo"
                                            style={{
                                                width: '340px',
                                                height: 'auto',
                                                margin: '50px 0',
                                                display: 'block',
                                                filter: 'drop-shadow(3px 3px 5px rgba(0, 0, 0, 0.6))'
                                            }}
                                        />
                                    </div>
                                    <p style={{
                                        textShadow: '3px 3px 6px rgba(0, 0, 0, 0.7)',
                                        color: '#fff',
                                        fontSize: '18px',
                                        lineHeight: '1.6'
                                    }}>
                                        A través de nuestra conexión con la Hacienda Zotoluca y la riqueza de la altiplanicie pulquera, nos posicionamos como un destino único que redefine la hospitalidad en Hidalgo.
                                    </p>
                                    <div className="slider-btn mt-30 mb-105">
                                        <Link to="/about" className="btn ss-btn active mr-15">Descubre Más</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Slider className="slider-active" {...home}>
                    <div className="col-xl-2">
                        <div className="single-slider slider-bg d-flex align-items-center" style={{
                            backgroundImage: `url(${bg1})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            position: 'relative',
                            height: isMobile ? '45vh' : '80vh'
                        }}>
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.4)'
                            }}></div>
                        </div>
                    </div>
                    {/* <div className="col-xl-2">
                        <div className="single-slider slider-bg d-flex align-items-center" style={{
                            backgroundImage: `url(${bg2})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            position: 'relative',
                            height: isMobile ? '45vh' : '80vh'
                        }}>
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)'
                            }}></div>
                        </div>
                    </div> */}
                </Slider>
            </section>

            <CloudbedsBookingWidget />
        </>
    );
}

export default Sliderhome;
